import { render, staticRenderFns } from "./ReportOrders.vue?vue&type=template&id=aae2e7d6&scoped=true&"
import script from "./ReportOrders.vue?vue&type=script&lang=js&"
export * from "./ReportOrders.vue?vue&type=script&lang=js&"
import style0 from "./ReportOrders.vue?vue&type=style&index=0&id=aae2e7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae2e7d6",
  null
  
)

export default component.exports